import React from 'react';
import { useSelector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import Header from '../../sections/header';
import PostsList from '../../sections/posts-list';
import { reactParserCommonOptions } from '../../../../app/functions';
import './index.scss';

const BaseRoute = () => {
  const { forumConfiguration } = useSelector((store) => store.config.Parameters);
  const translations = useSelector((store) => store.config.Translations);

  const displayPromotionalBanner = 'promotionalBanner' in forumConfiguration && forumConfiguration.promotionalBanner !== '';
  const displayWelcomeMessage = 'welcomeMessageHtml' in forumConfiguration && forumConfiguration.welcomeMessageHtml !== '';
  const displayBottomMessage = 'bottomMessageHtml' in forumConfiguration && forumConfiguration.bottomMessageHtml !== '';

  return (
    <div className="forum-base-route">
      <Header title={translations['forum_base_route_header_title']} />

      {(displayPromotionalBanner || displayWelcomeMessage) && (
        <div className="welcome-message">
          {displayPromotionalBanner && (
            <img
              src={forumConfiguration.promotionalBanner}
              alt="Promotional banner"
              className="welcome-message-banner"
            />
          )}

          {displayWelcomeMessage && (
            <div className="welcome-message-content">
              {ReactHtmlParser(forumConfiguration.welcomeMessageHtml, reactParserCommonOptions())}
            </div>
          )}
        </div>
      )}

      <PostsList />

      {displayBottomMessage && (
        <div className="bottom-message">
          {ReactHtmlParser(forumConfiguration.bottomMessageHtml, reactParserCommonOptions())}
        </div>
      )}
    </div>
  );
};

export default BaseRoute;
